/**
 * @author Fernando Ruano
 * @file constants.js
 * @description Role Constants
 */

// Generic actions
export const GET_ALL_ROLES = 'Roles/GET_ALL_ROLES';
export const GET_ROLE_BY_ID = 'Roles/GET_ROLE_BY_ID';
export const CREATE_ROLE = 'Roles/CREATE_ROLE';
export const UPDATE_ROLE = 'Roles/UPDATE_ROLE';
export const DELETE_ROLE_BY_ID = 'Roles/DELETE_ROLE_BY_ID';
export const CREATE_ROLE_PERMISSION = 'Roles/CREATE_ROLE_PERMISSION';
export const DELETE_ROLE_PERMISSION_BY_ID =
  'Roles/DELETE_ROLE_PERMISSION_BY_ID';
